// extracted by mini-css-extract-plugin
export default {"tabView":"SafetyAlertManagerView_tabView__u5co8"};